// extracted by mini-css-extract-plugin
module.exports = {"list":"CardIcons_list_2Mbog","card":"CardIcons_card_t-DLb","icon":"CardIcons_icon_3De7W"};